/*jshint esversion: 8 */
import React, { Component } from "react";
// import clsx from  'clsx';

import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";

// import CheckHandler from "../../../utils/CheckHandler";
import ITextField from "../../../components/UI/ITextField";

// store
import { observer } from "mobx-react";
import LocalStore from "./LocalStore";
import store from "../../../components/stores/Store";
import { toJS } from "mobx";

const styles = {};

class UpdateDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {};

    // 通用
    this.updateRecord = this.props.functions.updateRecord;
  }

  async componentDidMount() { }

  render() {
    return (
      <Dialog
        onClose={() => LocalStore.switchUpdateDialog()}
        open={LocalStore.updateDialogOpen}
      >
        <DialogTitle id="updateDialog" key='updateDialog'>修改信息</DialogTitle>
        <DialogContent>
          {
            LocalStore.tableFields.map((row) => {
              if (!row.tobeCreatedField) return null;
              return (
                <ITextField
                  key={row.sid}
                  margin="dense"
                  id={row.sid}
                  label={row.label}
                  variant="standard"

                  ivalue={LocalStore.updateRecordInfo[row.sid] || ''}
                  onChange={e => LocalStore.updateRecord(row.sid, e.target.value)}

                  type="text"
                  maxLength={row.maxLength || 20}
                  notNull={false}
                  style={{ width: '45%', marginLeft: '2%', marginRight: '2%' }}
                />
              );
            })
          }
        </DialogContent>
        <DialogActions>
          <Button
            onClick={(e) => this.updateRecord(e)}
            color="primary"
            variant="contained"
          >
            确认修改
          </Button>
          <Button
            onClick={(e) => LocalStore.switchUpdateDialog()}
            color="primary"
            variant="contained"
          >
            取消
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

const UpdateDialogObserver = observer(UpdateDialog);

UpdateDialogObserver.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(UpdateDialogObserver);
